<template>
  <div class="c-document-meta" :class="{highlight: highlight}">
    <div class="c-document-meta__icon">
      <file-icon v-if="version.file" :type="version.file.name|extension"></file-icon>
    </div>
    <div class="c-document-meta__content">
      <div class="c-document-meta__meta-row">
        <span
          class="c-document-meta__meta-row-item"
          v-if="document.policy_number"
        >{{document.policy_number}}</span>
        <span class="c-document-meta__meta-row-item">v{{ Number(version.version).toFixed(1) }}</span>
        <span
          class="c-document-meta__meta-row-item"
          v-if="document.primary_category"
        >{{document.primary_category.name}}</span>
        <span
          class="c-document-meta__meta-row-item align-right"
          v-if="showFull && $route.meta.isAdmin"
        >
          <router-link
            :to="{name: 'AdminDocumentEdit', params: {documentId: document.id}}"
            v-if="!$route.params.versionId && !document.archived"
          >Edit</router-link>
        </span>
      </div>
      <div class="c-document-meta__title">{{version.title}}</div>
      <div class="c-document-meta__meta-row">
        <span
          class="c-document-meta__meta-row-item"
          v-if="version.status"
        >{{version.status | capitalize}}</span>
      </div>

      <div class="c-document-meta__meta-row" v-if="showFull">
        <ul class="listless">
          <li>
            <strong>Tags:</strong>
            {{tagString}}
          </li>
          <li v-if="version.review_date">
            <strong>Review Date:</strong>
            {{$dayjs(version.review_date).format('DD / MM / YYYY')}}
          </li>
          <li>
            <strong>Responsible Users:</strong>
            {{userString}}
          </li>
          <li>
            <strong>Submitted By:</strong>
            {{this.document.created_user.name}} ({{this.document.created_user.email}})
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "document-meta",
  data() {
    return {
      version: {},
      created_user: {}
    };
  },
  props: {
    document: Object,
    highlight: {
      type: Boolean,
      default: false
    },
    showFull: {
      type: Boolean,
      default: false
    }
  },

  created() {
    if (this.document.current_version) {
      this.version = this.document.current_version;
    } else {
      this.$store
        .dispatch("documents/getVersion", {
          documentId: this.$route.params.id,
          versionId: this.$route.params.versionId
        })
        .then(resp => {
          this.version = resp;
        });
    }
  },

  computed: {
    ...mapState('documents',['currentDocument']),
    /**
     * comma-separated list of tags
     */
    tagString() {
      const tags = this.document.tags;

      if (!tags || tags.length == 0) {
        return "(No tags added)";
      }

      let returnString = tags[0].name;

      tags.forEach((tag, i) => {
        if (i > 0) {
          returnString += `, ${tag.name}`;
        }
      });

      return returnString;
    },
    /**
     * comma-separated list of users
     */
    userString() {
      let primary;
      let secondary;

      if (!this.currentDocument.primary_user) {
        primary = "";
      } else {
        primary =
          this.currentDocument.primary_user.name != ""
            ? this.currentDocument.primary_user.name
            : this.currentDocument.primary_user.email;
      }

      if (!this.currentDocument.secondary_user) {
        secondary = "";
      } else {
        secondary =
          this.currentDocument.secondary_user.name != ""
            ? `, ${this.currentDocument.secondary_user.name}`
            : `, ${this.currentDocument.secondary_user.email}`;
      }

      if (primary.length < 1 && secondary.length < 1) {
        return "(no users assigned)";
      } else if (primary.length < 1 && secondary.length > 1) {
        return secondary.split(", ")[1];
      } else {
        return `${primary} ${secondary}`;
      }
    }
  }
};
</script>

<style lang="scss">
.c-document-meta {
  display: flex;

  .c-file-icon {
    width: 60px;
    height: 60px;
  }

  &__icon {
    flex: 1;
  }

  &__content {
    padding-left: 0.5em;
    flex: 6;
  }

  &__meta-row {
    color: $colour-nhs-dark-grey;
    font-size: 14px;
    margin-bottom: 0.25em;
  }

  &__meta-row-item:not(:last-of-type) {
    margin-right: 1em;
  }

  &__title {
    font-size: 20px;
    color: #202020;
    margin-bottom: 0.25em;
  }

  &.highlight {
    background: $colour-nhs-core-white;
    border: 1px solid $colour-nhs-med-grey;
    padding: 20px;
    border-radius: 4px;
  }

  .align-right {
    float: right;
  }

  a {
    text-decoration: none;
  }
}
</style>

